import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('active')
  }

  hide(event) {
    // Don't hide if clicking inside the menu
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.remove('active')
    }
  }

  connect() {
    // Close dropdown when clicking outside
    this.boundHide = this.hide.bind(this)
    document.addEventListener('click', this.boundHide)
  }

  disconnect() {
    document.removeEventListener('click', this.boundHide)
  }
}

